import { render, staticRenderFns } from "./employeesabsenteeism-add-or-update.vue?vue&type=template&id=d562fb84&"
import script from "./employeesabsenteeism-add-or-update.vue?vue&type=script&lang=js&"
export * from "./employeesabsenteeism-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports